import type { UseCardDisplayReturn } from "@apac/checkout";
import { type CardType, CardTypeCollection } from "@hopper-b2b/types";
import { getCardByBin } from "@hsbc/utilities";
import dayjs from "dayjs";

const dateToCardFormat = ({ month, year }: { month: number; year: number }) =>
  dayjs(`${month}/${year}`, "M/YYYY").format("MM/YY");

export const useCardDisplay = (): UseCardDisplayReturn => ({
  formatCardExpiry: dateToCardFormat,
  getCardDisplayName: (bin: string, cardType: CardType) =>
    getCardByBin(bin, false)?.name ?? CardTypeCollection[cardType],
});
